<nb-action class="close-dialog" icon="close-outline" (click)="closeAction()"></nb-action>
<nb-card>
  <nb-card-header>Ajouter un compte externe</nb-card-header>
  <nb-card-body>
    <form [formGroup]="editForm">
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <div class="form-group">
            <label>Nom *</label>
            <input type="text" class="form-control" formControlName="name" />
          </div>
          <hr/>
          <div class="form-group">
            <label>S'agit t'il d'une coop ? *</label>
            <nb-radio-group formControlName="isCoop" style="display: block;">
              <nb-radio [value]="true" style="display: inline;">Oui</nb-radio>
              <nb-radio [value]="false" style="display: inline;">Non</nb-radio>
            </nb-radio-group>
          </div>
          @if (editForm.get('isCoop')?.value) {
            <div>
              <div class="form-group">
                <label for="logo" style="display: block;">Télécharger un logo</label>
                <input type="file" id="logo" (change)="onFileChange($event)" fullWidth/>
              </div>
              <div class="form-group">
                <label>Thème CSS</label>
                <nb-select formControlName="cssTheme" fullWidth>
                  @for (theme of cssThemes; track theme) {
                    <nb-option [value]="theme">{{ theme }}</nb-option>
                  }
                </nb-select>
              </div>
              <div class="form-group">
                <label>Mode d'affichage</label>
                <nb-select formControlName="coopDisplayMode" fullWidth>
                  @for (mode of coopDisplayModes; track mode) {
                    <nb-option [value]="mode.value">{{ mode.label }}</nb-option>
                  }
                </nb-select>
              </div>
            </div>
          }
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="form-group">
            <label>Types d'animaux : *</label>
            @for (animalType of animalTypes; track animalType) {
              <div class="animal-type-option">
                <nb-checkbox
                  [checked]="isAnimalTypeSelected(animalType.id)"
                  (checkedChange)="onAnimalTypeToggle(animalType.id, $event)">
                  {{ animalType.label }}
                </nb-checkbox>
              </div>
            }
            @if (selectedAnimalTypeIds.size === 0) {
              <small class="text-danger">
                Au moins un type d'animal doit être sélectionné
              </small>
            }
          </div>
          <hr/>
          <div class="form-group">
            <label>Type d'export *</label>
            <nb-select formControlName="exportType" fullWidth>
              @for (type of exportTypes; track type) {
                <nb-option [value]="type.value">{{ type.label }}</nb-option>
              }
            </nb-select>
          </div>
          @if (editForm.get('exportType')?.value == 'FTP') {
            <div>
              <div class="form-group">
                <label>Répertoire FTP (a créer sur le FTP)</label>
                <input type="text" class="form-control" formControlName="ftpPath" />
              </div>
              <div class="form-group">
                <label>Format fichier</label>
                <input type="text" class="form-control" formControlName="ftpFileFormat" />
              </div>
            </div>
          }
          @if (editForm.get('exportType')?.value == 'API') {
            <div class="form-group">
              <label>Date expiration</label>
              <nb-form-field>
                <nb-icon nbSuffix icon="calendar-outline"></nb-icon>
                <input nbInput [nbDatepicker]="startDatepicker" autocomplete="off"
                  formControlName="expirationDate" />
              </nb-form-field>
              <nb-datepicker #startDatepicker format="dd/MM/yyyy"></nb-datepicker>
            </div>
          }
        </div>
      </div>
    </form>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton fullWidth status="primary" shape="round" (click)="saveAction()" class="mb-2" [disabled]="(!isFormValid() || loading)">{{
    (extern) ? 'Enregistrer' : 'Ajouter' }}</button>
  </nb-card-footer>
</nb-card>
